/*
 * Mega menü (snippets/aycan-mega-menu.liquid). Açılış temanın kendi mantığında (hover:
 * aycan-facets.js, tıklama: <details>); bu dosya şunları yapar:
 *   - Soldaki koleksiyon satırı sağdaki önizlemeyi seçer, pembe vurgu o satıra kayar.
 *   - Panel details'in DIŞINDA (kapanış animasyonu için) ve kimliği `Details-` ile
 *     başlamıyor (bkz. snippet), bu yüzden temanın Esc, aria-expanded ve odak-kaybı
 *     kapatması burada karşılanır.
 *   - Fareyle menüden çıkınca kapanır: temanın hover kodu kapatmayı bir SONRAKİ öğeye
 *     girilince planlıyor; fare menüden boş bir alana çıkınca yeni öğe gelmiyor, menü
 *     açık kalıyordu.
 *   - Fareyle "Shop"a tıklamak menüyü kapatmaz: üstüne gelince zaten açıldığı için tıklama
 *     onu hemen geri kapatıyordu. Klavye ve dokunmatikte tıklama aç/kapa olarak kalır.
 *   - İlk açılışta bütün önizleme görselleri yüklenmeye başlar; koleksiyon değişince
 *     boş kutu görünmesin.
 *
 * Fareyle kısa bir bekleme (INTENT_MS): satırdan sağdaki ürünlere çapraz giderken aradaki
 * satırların üstünden geçilir; bekleme olmasa önizleme o satırlara atlar.
 */
(() => {
  if (window.aycanMegaMenu) return;
  window.aycanMegaMenu = true;

  const INTENT_MS = 90;
  const CLOSE_MS = 200;
  const desktop = window.matchMedia('(min-width: 990px) and (hover: hover)');
  let intentTimer;
  let closeTimer;
  let lastPointer = '';

  const menuOf = (el) => (el && el.closest ? el.closest('header-menu') : null);
  const detailsOf = (menu) => (menu ? menu.querySelector(':scope > details.aycan-megab') : null);

  // Konum kutu ölçüsünden: offsetTop satırların listesine (ul, position: relative) göre
  // döner, vurgu ise listenin sarmalayıcısında; etiket yüksekliği kadar kayıyordu.
  const movePill = (card, row, animate) => {
    const pill = card.querySelector('.aycan-megab__pill');
    const box = pill && pill.parentElement;
    if (!pill || !row || !row.offsetHeight) return;
    const r = row.getBoundingClientRect();
    const y = r.top - box.getBoundingClientRect().top;
    card.classList.toggle('is-moving', !!animate);
    pill.style.setProperty('--y', `${Math.round(y)}px`);
    pill.style.setProperty('--h', `${Math.round(r.height)}px`);
    card.classList.add('is-pill');
  };

  const activate = (row) => {
    const card = row.closest('.aycan-megab__card');
    if (!card || row.classList.contains('is-on')) return;
    const key = row.dataset.megabRow;
    card.querySelectorAll('[data-megab-row]').forEach((r) => r.classList.toggle('is-on', r === row));
    card.classList.add('is-switching');
    card.querySelectorAll('[data-megab-pane]').forEach((p) => { p.hidden = p.dataset.megabPane !== key; });
    movePill(card, row, true);
  };

  const close = (details, focusSummary) => {
    if (!details || !details.hasAttribute('open')) return;
    details.removeAttribute('open');
    const summary = details.querySelector(':scope > summary');
    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
      if (focusSummary) summary.focus();
    }
  };

  // Açılış: vurguyu seçili satıra animasyonsuz yerleştir, görselleri yüklemeye başla.
  document.addEventListener('toggle', (e) => {
    const details = e.target;
    if (!(details instanceof HTMLDetailsElement) || !details.classList.contains('aycan-megab')) return;
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open));
    if (!details.open) return;
    const card = menuOf(details)?.querySelector('.aycan-megab__card');
    if (!card) return;
    card.classList.remove('is-switching');
    requestAnimationFrame(() => movePill(card, card.querySelector('.aycan-megab__row.is-on'), false));
    if (!card.dataset.megabWarm) {
      card.dataset.megabWarm = '1';
      card.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
    }
  }, true);

  document.addEventListener('pointerdown', (e) => { lastPointer = e.pointerType; }, true);

  document.addEventListener('click', (e) => {
    const summary = e.target.closest && e.target.closest('details.aycan-megab > summary');
    if (!summary || !desktop.matches || lastPointer !== 'mouse' || e.detail === 0) return;
    if (summary.parentElement.open) e.preventDefault();
  });

  document.addEventListener('pointerover', (e) => {
    const menu = menuOf(e.target);
    if (menu && detailsOf(menu)) clearTimeout(closeTimer);
    const row = e.target.closest && e.target.closest('[data-megab-row]');
    if (!row) return;
    clearTimeout(intentTimer);
    if (e.pointerType === 'mouse') intentTimer = setTimeout(() => activate(row), INTENT_MS);
    else activate(row);
  });

  document.addEventListener('pointerout', (e) => {
    const row = e.target.closest && e.target.closest('[data-megab-row]');
    if (row && !row.contains(e.relatedTarget)) clearTimeout(intentTimer);

    if (!desktop.matches || e.pointerType !== 'mouse') return;
    const menu = menuOf(e.target);
    const details = detailsOf(menu);
    if (!details || !details.open || menu.contains(e.relatedTarget)) return;
    // Klavyeyle içeride odak varsa fare çıkışı menüyü kapatmaz.
    if (menu.contains(document.activeElement) && document.activeElement.matches(':focus-visible')) return;
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => close(details, false), CLOSE_MS);
  });

  document.addEventListener('focusin', (e) => {
    const row = e.target.closest && e.target.closest('[data-megab-row]');
    if (row) activate(row);
  });

  // Odak menünün dışına çıkınca kapan (temanınki yalnız details içini izliyor).
  document.addEventListener('focusout', (e) => {
    const menu = menuOf(e.target);
    const details = detailsOf(menu);
    if (!details || !details.open) return;
    setTimeout(() => {
      if (!menu.contains(document.activeElement)) close(details, false);
    });
  });

  document.addEventListener('keyup', (e) => {
    if (e.key !== 'Escape') return;
    const details = detailsOf(menuOf(e.target));
    if (details && details.open) close(details, true);
  });
})();
